module.exports = __webpack_public_path__ + "static/media/socialtk.41fb0d2c.svg";